import Button from "../library/Button";
import Image from "next/image";
import React from "react";
import clsx from "clsx";

export const HeroTitle = ({ title }: { title: string }) => {
  return (
    <h1
      className={clsx(
        "text-5xl",
        "md:text-7xl",
        "font-medium",
        "mx-auto",
        "text-center",
        "tracking-tight",
        "md:leading-16",
        "px-12",
        "md:px-0",
        "max-w-lg",
        "md:max-w-sm",
        "md:mt-12",
        "lg:mt-0"
      )}
    >
      {title}
    </h1>
  );
};

export const HeroDescription = ({ description }: { description: string }) => {
  return (
    <p
      className={clsx(
        "text-lg",
        "md:text-2xl",
        "max-w-md",
        "lg:max-w-sm",
        "mx-auto",
        "text-center",
        "px-12",
        "lg:px-0",
        "lg:mt-0",
        "mt-2",
        "mb-8",
        "lg:mb-0",
        "leading-tight",
        "md:max-w-xl",
        "md:mt-8"
      )}
    >
      {description}
    </p>
  );
};

export const BackgroundImage = () => {
  return (
    <Image
      src="/images/hero.webp"
      alt="Gail Hero Background"
      fill
      quality={100}
      loading="eager"
      className={clsx("absolute inset-0 z-0", "object-cover", "object-center")}
    />
  );
};

// Type definition for AI types
export type AiType = {
  label: string;
  key: string;
  index?: number;
};

export const HeroAiTypeButtons = ({
  aiTypes,
  isMobile,
  onSuggestionClick,
}: {
  aiTypes: AiType[];
  isMobile?: boolean;
  onSuggestionClick: (key: string, index: number) => void;
}) => {
  return (
    <div
      className={clsx("flex", "flex-wrap", "gap-1", "justify-center", {
        "mt-2": isMobile,
      })}
    >
      {aiTypes
        .filter((_, index) => !isMobile || index !== 2)
        .map((aiType) => (
          <Button
            type="tertiary"
            key={aiType.key}
            className={clsx(
              "[&>span]:!text-xs",
              "[&>span]:!font-normal",
              "[&>span]:!text-shadow-none",
              "!rounded-lg",
              "bg-white/80",
              "backdrop-blur-xs",
              "rounded-2xl"
            )}
            onClick={() => onSuggestionClick(aiType.key, aiType.index || 0)}
          >
            {aiType.label}
          </Button>
        ))}
    </div>
  );
};
